<template>
  <div class="">
    <div class="table-wrap">
      <a-row justify="start" type="flex" :gutter="22">
        <a-col :span="6">
          <a-input-search
            placeholder="请输入关键字"
            @search="onSearch"
            @change="onSearch"
            size="default"
            v-model="keyword"
          />
        </a-col>
        <a-col>
          <a-button
            type="primary"
            @click="openModal()"
            style="margin-right: 5px;"
            >添加课程</a-button
          >
          <a-popconfirm
            title="确定要删除吗 ?"
            @confirm="() => onDeleteInBatch()"
          >
            <a-icon slot="icon" type="question-circle-o" style="color: red" />
            <a-button type="default"><a-icon type="delete" />删除选中</a-button>
          </a-popconfirm>
        </a-col>
      </a-row>
      <a-row style="margin-top: 10px">
        <a-table
          :columns="columns"
          :rowKey="record => record.id"
          :dataSource="tableData"
          :bordered="true"
          :rowClassName="tableRowClass"
          :rowSelection="rowSelection"
          :pagination="pagination"
          @change="paginationChange"
        >
          <template slot="video" slot-scope="arr, record">
            <div
              class="upload-panel clearfix"
              v-if="uploadMap[record.id] === true"
            >
              <VideoUpload
                @uploaded="res => uploaded(res, record.id)"
                @cancel="() => onClickUploadCancel(record.id)"
                :max="700"
              />
            </div>
            <div v-else>
              <p class="video-text">
                <span>
                  <a
                    v-if="arr.length > 0"
                    :href="arr[0] && arr[0].url"
                    target="_blank"
                    >{{ arr[0] && arr[0].name }}</a
                  >
                  <span v-else>暂无视频</span>
                </span>
              </p>
              <div class="video-desc">
                <ul class="video-actions clearfix actions-left">
                  <li class="video-actions-item">
                    <span>
                      <label for="">时长：</label>
                      <span>{{ arr[0] && arr[0].duration | duration }}</span>
                    </span>
                  </li>
                </ul>
                <ul class="video-actions clearfix actions-right">
                  <li class="video-actions-item">
                    <span @click="onClickUpload(record.id)">
                      <a-icon type="upload"></a-icon>
                    </span>
                  </li>
                  <li v-if="arr.length > 0" class="video-actions-item">
                    <a-popconfirm
                      title="确定要删除吗 ?"
                      @confirm="() => onDeleteVideo(record.id)"
                    >
                      <span>
                        <a-icon type="delete"></a-icon>
                      </span>
                    </a-popconfirm>
                  </li>
                </ul>
              </div>
            </div>
          </template>
          <template slot="attach" slot-scope="text">
            <mini-tags :list="text" />
          </template>
          <template slot="icon" slot-scope="text">
            <a-avatar
              style="margin-right: 6px;"
              shape="square"
              size="large"
              :src="text"
              >无图</a-avatar
            >
          </template>
          <template slot="cell" slot-scope="text">
            <format-html :text="text" :keyword="keyword" />
          </template>
          <template slot="operation" slot-scope="text, record">
            <a
              @click="e => openModal(record.id)"
              href="javascript:;"
              style="margin-right: 20px;"
            >
              <a-icon type="edit" /> 修改
            </a>
            <a-popconfirm
              v-if="tableData.length"
              title="确定删除吗 ?"
              @confirm="() => onDelete(record.id)"
            >
              <a href="javascript:;"> <a-icon type="delete" /> 删除 </a>
            </a-popconfirm>
          </template>
        </a-table>
      </a-row>
    </div>
    <CourseForm v-model="visible" :afterSubmit="afterSubmit" :mode="mode" />
  </div>
</template>

<script>
import CourseForm from './CourseForm'
import { searchCourse, deleteCourse, updateCourse } from '@/api/course/course'
import moment from 'moment'
import VideoUpload from '@/components/Upload/VideoUpload'

export default {
  components: {
    CourseForm,
    VideoUpload
  },
  data() {
    return {
      columns: [],
      tableData: [],
      rowKeys: [],
      rowSelection: {
        onChange: selectedRowKeys => {
          this.rowKeys = selectedRowKeys
        }
      },
      pagination: {
        showSizeChanger: true,
        defaultCurrent: 1,
        defaultPageSize: 10,
        showTotal: total => {
          return `共 ${total} 条数据`
        }
      },
      keyword: '',
      visible: false,
      mode: {
        type: 'add',
        id: null
      },
      afterSubmit: () => {
        this.fetchData()
      },
      uploadMap: {}
    }
  },
  created() {
    this.columns = [
      {
        title: '封面',
        dataIndex: 'icon',
        scopedSlots: { customRender: 'icon' }
        // width: 55,
        // fixed: 'left'
      },
      {
        title: '课程名称',
        dataIndex: 'name',
        scopedSlots: { customRender: 'cell' }
        // width: 150,
        // fixed: 'left'
      },
      {
        title: '描述',
        dataIndex: 'description',
        scopedSlots: { customRender: 'cell' }
        // width: 200
      },
      {
        title: '难度级别',
        dataIndex: 'level',
        // width: 150,
        scopedSlots: { customRender: 'cell' }
      },
      {
        title: '讲师',
        dataIndex: 'teacher',
        // width: 150,
        scopedSlots: { customRender: 'cell' }
      },
      {
        title: '类型',
        dataIndex: 'category',
        // width: 150,
        scopedSlots: { customRender: 'cell' }
      },
      {
        title: '浏览次数',
        dataIndex: 'browseCount',
        scopedSlots: { customRender: 'cell' }
        // width: 100
      },
      {
        title: '视频',
        dataIndex: 'videos',
        scopedSlots: { customRender: 'video' }
        // width: 280
      },
      {
        title: '创建时间',
        dataIndex: 'createdAt',
        scopedSlots: { customRender: 'cell' },
        // width: 150,
        customRender: text => {
          return moment(text).format('YYYY-MM-DD HH:mm:ss')
        }
      },
      {
        title: '上次修改时间',
        dataIndex: 'updatedAt',
        scopedSlots: { customRender: 'cell' },
        // width: 150,
        customRender: text => {
          return moment(text).format('YYYY-MM-DD HH:mm:ss')
        }
      },
      {
        title: '附件',
        dataIndex: 'attachs',
        scopedSlots: { customRender: 'attach' }
        // width: 100
      },
      {
        // width: 150,
        title: '操作',
        dataIndex: 'operation',
        scopedSlots: { customRender: 'operation' }
        // fixed: 'right'
      }
    ]
    this.fetchData()
  },
  methods: {
    fetchData() {
      let { keyword, pagination } = this
      keyword = keyword.trim()
      const page = pagination.current || pagination.defaultCurrent
      const size = pagination.size || pagination.defaultPageSize
      searchCourse({ multiple: false, keyword, page, size }).then(resp => {
        let { result: res } = resp
        this.tableData = res.rows
        pagination.total = res.total
        this.pagination = JSON.parse(JSON.stringify(pagination))
      })
    },
    paginationChange(pagination) {
      this.pagination = pagination
      this.fetchData()
    },
    onSearch() {
      this.pagination.current = 1
      this.fetchData()
    },
    tableRowClass(record, index) {
      if (index % 2 === 0) {
        return 'row-class-even'
      } else {
        // return 'row-class-odd'
        return 'row-class-even'
      }
    },
    onDelete(id) {
      const ids = [id].join(',')
      this.delete(ids)
    },
    delete(ids = '') {
      deleteCourse({ ids }).then(() => {
        this.fetchData()
        this.$notification['success']({
          message: '成功',
          description: '删除成功',
          duration: 3
        })
      })
    },
    onDeleteInBatch() {
      const { rowKeys } = this
      if (rowKeys && rowKeys.length > 0) {
        const ids = rowKeys.join(',')
        this.delete(ids)
        this.fetchData()
      }
    },
    openModal(id) {
      this.visible = true
      if (id) {
        this.mode = {
          type: 'update',
          id
        }
      } else {
        this.mode = {
          type: 'add'
        }
      }
    },
    onSetting(id) {
      this.$router.push({
        name: 'section',
        query: {
          courseId: id
        }
      })
    },
    onClickUpload(id) {
      const map = this.uploadMap || {}
      map[id] = true
      this.uploadMap = JSON.parse(JSON.stringify(map))
    },
    onClickUploadCancel(id) {
      const map = this.uploadMap || {}
      map[id] = false
      this.uploadMap = JSON.parse(JSON.stringify(map))
    },
    onDeleteVideo(id) {
      updateCourse(id, {
        videos: []
      }).then(resp => {
        if (resp.code === 200) {
          this.$notification['success']({
            message: '成功',
            description: '删除成功'
          })
          this.fetchData()
        }
      })
    },
    uploaded(res, id) {
      const data = res || {}
      updateCourse(id, {
        videos: [
          {
            name: data.name,
            fileId: data.id,
            url: data.url,
            duration: data.duration
          }
        ]
      }).then(resp => {
        if (resp.code === 200) {
          this.$notification['success']({
            message: '成功',
            description: '上传成功'
          })
          this.fetchData()
          setTimeout(() => {
            const map = this.uploadMap || {}
            map[id] = false
            this.uploadMap = JSON.parse(JSON.stringify(map))
          }, 1500)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.upload-panel {
  padding-right: 20px;
  .upload-panel-cancel {
    float: right;
  }
}
.video-text {
  margin-bottom: 5px;
}
.actions-left {
  float: left;
}
.actions-right {
  float: right;
}
.video-actions {
  list-style: none;
  margin: 0;
  padding: 0;
  .video-actions-item {
    list-style: none;
    float: left;
    padding: 0 16px;
    border-right: 1px solid #b9b9b9;
    &:first-child {
      padding-left: 0;
    }
    &:last-child {
      border-right: none;
    }
    &:hover {
      color: red;
    }
  }
}
</style>
